module.exports = __webpack_public_path__ + "static/media/5Emojis.87492b48.png";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/5Emojis.png
// module id = 3795
// module chunks = 0